/**
 * Rider Settlement API
 * 라이더 주정산내역 API
 */
import { apiClient } from "@/shared/api/client";
import {
    GetRiderSettlementListResponseDto,
    GetLatestSettlementDateResponseDto,
    ApiResponseDto
} from "../types/riderSettlement.types";
import { uploadSettlementFile, buildExcelDownloadUrl, downloadExcelFile } from "@/shared/utils/settlementApiHelpers";
import { formatDateToISO } from "@/shared/utils/dateUtils";

const BASE_PATH = '/api/v1/rider-settlement';

/**
 * Rider Settlement API 서비스
 */
export const riderSettlementApi = {
    /**
     * 라이더 주정산내역 목록 조회
     * GET /api/v1/rider-settlement?acctStDate={startDate}&acctEdDate={endDate}&riderName={name}&supplierId={id}
     */
    getRiderSettlementList: async (
        acctStDate: string,
        acctEdDate: string,
        riderName?: string,
        supplierId?: string
    ): Promise<GetRiderSettlementListResponseDto> => {
        // 날짜를 ISO 형식으로 변환
        const formattedStartDate = formatDateToISO(acctStDate);
        const formattedEndDate = formatDateToISO(acctEdDate);

        // URL을 직접 구성하여 배열 직렬화 문제 방지
        let url = `${BASE_PATH}?acctStDate=${formattedStartDate}&acctEdDate=${formattedEndDate}`;
        if (riderName && riderName.trim() !== '') {
            url += `&riderName=${encodeURIComponent(riderName)}`;
        }
        if (supplierId) {
            url += `&supplierId=${supplierId}`;
        }

        const response = await apiClient.get<GetRiderSettlementListResponseDto>(url);
        return response.data;
    },

    /**
     * 최근 정산일자 조회 (시작일, 종료일)
     * GET /api/v1/rider-settlement/latest-date
     */
    getLatestSettlementDate: async (): Promise<GetLatestSettlementDateResponseDto> => {
        const response = await apiClient.get<GetLatestSettlementDateResponseDto>(`${BASE_PATH}/latest-date`);
        return response.data;
    },

    /**
     * 엑셀 파일 업로드 (정산 데이터 등록)
     * POST /api/v1/rider-settlement/upload
     */
    uploadSettlementFile: async (file: File, userId: string): Promise<ApiResponseDto> => {
        return uploadSettlementFile(BASE_PATH, file, userId);
    },

    /**
     * 엑셀 다운로드
     * GET /api/v1/rider-settlement/excel?acctStDate={startDate}&acctEdDate={endDate}&riderName={name}
     */
    downloadExcel: async (
        acctStDate: string,
        acctEdDate: string,
        riderName?: string
    ): Promise<Blob> => {
        const url = buildExcelDownloadUrl(BASE_PATH, {
            acctStDate,
            acctEdDate,
            riderName: riderName && riderName.trim() !== '' ? riderName : undefined
        });
        return downloadExcelFile(url);
    }
};
